<template>
  <div id="exclusive" :class="{ h5: $store.state.webType === 'h5' }">
    <el-row :span="24" class="page">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{
            $t('home')
          }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('sections') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('exclusive') }}</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="banner-view">
        <div class="banner-col">
          <div>
            <el-carousel
              ref="carousel"
              :height="bannerHeight + 'px'"
              :initial-index="currentIndex"
              indicator-position="none"
              trigger="click"
              @change="changeBanner"
            >
              <el-carousel-item
                v-for="(banner, bdx) in bannerData"
                :key="bdx"
                :name="bdx + ''"
              >
                <div class="carousel-view">
                  <img
                    :alt="
                      $store.state.lang == 'CN'
                        ? banner.title
                        : banner.titleEnglish
                    "
                    :src="banner.imgUrlMax"
                    class="banner-big"
                    @click.stop="$goDetail(banner.id)"
                  />
                  <div
                    v-if="$store.state.webType === 'pc'"
                    class="content-view"
                    @click.stop="$goDetail(banner.id)"
                  >
                    <div class="item-title">
                      {{
                        $store.state.lang == 'CN'
                          ? banner.title
                          : banner.titleEnglish
                      }}
                    </div>
                    <div class="item-content">
                      {{
                        $store.state.lang == 'CN'
                          ? banner.content
                          : banner.contentEnglish
                      }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-if="$store.state.webType === 'pc'" class="col-text">
            <template v-for="(banner, bdx) in bannerData">
              <!--              @click="changeBanner(bdx)"-->
              <div
                :class="{ active: currentIndex == bdx }"
                class="text-item"
                @click.stop="$goDetail(banner.id)"
              >
                <div class="two-line">
                  {{
                    $store.state.lang == 'CN'
                      ? banner.title
                      : banner.titleEnglish
                  }}
                </div>
              </div>
            </template>
          </div>
          <div v-if="$store.state.webType === 'h5'" class="col-text">
            <template v-for="(banner, bdx) in bannerData">
              <div
                v-show="currentIndex == bdx"
                :class="{ active: currentIndex == bdx }"
                class="text-item"
                @click.stop="$goDetail(banner.id)"
              >
                <div class="two-line">
                  {{
                    $store.state.lang == 'CN'
                      ? banner.title
                      : banner.titleEnglish
                  }}
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="int-col">
          <div class="label-view" v-if="$store.state.lang != 'EN'">
            <div class="int-label">
              {{ $t('review') }} <img src="@/assets/images/label-icon.png"/>
            </div>
          </div>
          <template v-for="(banner, bdx) in bannerData">
            <div v-show="currentIndex === bdx" class="int-content">
              <div class="content-title">
                <div class="two-line">
                  {{
                    $store.state.lang == 'CN'
                      ? bannerData[currentIndex].title
                      : bannerData[currentIndex].titleEnglish
                  }}
                </div>
              </div>
              <div
                v-if="
                  ($store.state.lang == 'CN' &&
                    bannerData[currentIndex].content) ||
                  ($store.state.lang != 'CN' &&
                    bannerData[currentIndex].contentEnglish)
                "
                class="content-import"
              >
                <div class="two-line">
                  <img class="mh01" src="@/assets/images/gjgc-mh01.png"/>
                  <img class="mh02" src="@/assets/images/gjgc-mh02.png"/>
                  {{
                    $store.state.lang == 'CN'
                      ? bannerData[currentIndex].content
                      : bannerData[currentIndex].contentEnglish
                  }}
                </div>
              </div>
              <div
                class="content-html"
                v-if="bannerData[currentIndex].bannerContent"
                v-html="bannerData[currentIndex].bannerContent
                "
              ></div>
              <div
                class="content-html"
                v-else
                v-html="
                  $store.state.lang == 'CN'
                    ? bannerData[currentIndex].detailHtml
                    : bannerData[currentIndex].detailHtmlEnglish
                "
              ></div>
              <div
                class="int-more"
                @click="$goDetail(bannerData[currentIndex].id)"
              >
                {{ $t('more') }} >
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-row>
    <div :span="24" class="page-content">
      <el-row :span="24" class="art-row">
        <div class="art-col">
          <!-- 文章label的tab -->
          <div class="art-tab">
            <div
              :class="{ active: currentLabel == '' }"
              class="tab-item"
              @click="changeLabel('', '')"
            >
              {{ $t('all') }}
            </div>
            <template v-if="labelData && labelData.length > 0">
              <div
                v-for="(item, index) in labelData"
                :key="index"
                :class="{ active: currentLabel == item.label }"
                class="tab-item"
                @click="changeLabel(item.id, item.label)"
              >
                {{ item.label }}
              </div>
            </template>
            <!-- 右侧切换视图和总条数 -->
            <div class="tab-info">
              <div class="info-total">
                {{
                  $t('results').length > 6
                    ? listTotal + '  ' + $t('results')
                    : `共 ${listTotal} 条`
                }}
              </div>
              <div class="toggle-img" @click="viewTypeChange('img')">
                <img
                  v-if="currentView !== 'img'"
                  src="@/assets/images/use/art-view01.png"
                  title="图文列表"
                />
                <img
                  v-if="currentView === 'img'"
                  src="@/assets/images/use/art-view11.png"
                  title="图文列表"
                />
              </div>
              <div class="toggle-text" @click="viewTypeChange('text')">
                <img
                  v-if="currentView !== 'text'"
                  src="@/assets/images/use/art-view02.png"
                  title="文字列表"
                />
                <img
                  v-if="currentView === 'text'"
                  src="../assets/images/use/art-view22.png"
                  title="文字列表"
                />
              </div>
            </div>
          </div>
          <infinite-scroll class="infinite" @loadBottom="loadMore">
            <div
              v-masonry
              :class="{ text: currentView === 'text' }"
              :fit-width="false"
              :gutter="gutterWidth"
              :horizontal-order="true"
              class="art-view"
              item-selector=".art-item"
              style="height: auto"
              transition-duration="0s"
            >
              <template v-if="currentView === 'img'">
                <div
                  v-for="(img, idx) in artData"
                  :key="idx"
                  v-masonry-tile
                  class="art-item scale-view"
                  @click="$goDetail(img.id)"
                >
                  <img :alt="img.title" :src="img.imgUrl"/>
                  <div class="art-content">
                    <div class="item-title two-line">
                      {{ img.title }}
                    </div>
                    <div class="item-info">
                      <!-- <div
                        class="info-label"
                        v-if="
                          img.label &&
                          img.label.length > 0 &&
                          $store.state.lang === 'CN'
                        "
                      >
                        {{currentLabel ? currentLabel : img.label[0]}}
                      </div> -->
                      <div class="info-time">{{ img.peridos }}</div>
                    </div>
                    <!-- <div class="item-content">{{img.content}}</div> -->
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(img, idx) in artData"
                  :key="idx"
                  v-masonry-tile
                  class="art-item"
                  @click="$goDetail(img.id)"
                >
                  <div class="art-content">
                    <div class="item-title">
                      {{ img.title }}
                      <div class="item-info">
                        <!-- <div
                          class="info-label"
                          v-if="
                            img.label &&
                            img.label.length > 0 &&
                            $store.state.lang === 'CN'
                          "
                        >
                          {{currentLabel ? currentLabel : img.label[0]}}
                        </div> -->
                        <div class="info-time">{{ img.peridos }}</div>
                      </div>
                    </div>
                    <!-- <div class="item-content">{{img.content}}</div> -->
                  </div>
                </div>
              </template>
              <br/>
              <div
                v-if="listQuery.pageNum < maxPage"
                class="art-more true"
                @click="getListMore()"
              >
                {{ $t('more2') }} >
              </div>
              <div v-else class="art-more none">{{ $t('noMore') }}</div>
            </div>
          </infinite-scroll>
        </div>
        <!-- 右侧{{$t('latest')}} 热点文章 -->
        <div class="row-right">
          <!-- {{$t('latest')}} -->

          <hot-article></hot-article>
          <new-book></new-book>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import HotArticle from '@/components/HotArticle';
import NewBook from '@/components/NewBook';

export default {
  name: 'Exclusive',
  components: {
    HotArticle,
    NewBook
  },
  data() {
    return {
      busy: true,
      nomore: false,
      gutterWidth: 20,

      // banner数据
      bannerData: [],
      // 热点聚焦
      international: {},
      // 当前展示的banner index
      currentIndex: 0,
      // {{$t('latest')}}
      bookData: {},
      // 热点文章
      articleData: [],
      // 当前文章列表展示形式
      currentView: 'img',
      // 文章列表
      artData: [],
      // 文章总数量
      listTotal: 0,
      maxPage: 1,
      // 文章列表请求信息
      listQuery: {
        columnId: '',
        labelId: '',
        pageSize: 10,
        pageNum: 1,
      },
      // 标签
      labelData: [],
      currentLabel: '',

      bannerHeight: 0, // 轮播图容器高度;
      screenWidth: 0, // 页面宽度
    };
  },
  mounted() {
    if (this.$route.query.token) {
      sessionStorage.setItem('token', this.$route.query.token);
    }
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (600 / 1920) * this.screenWidth;
    if (this.$store.state.webType === 'h5') {
      this.bannerHeight += 50;
    }
    // 窗口大小发生改变
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (600 / 1920) * this.screenWidth;
      if (this.$store.state.webType === 'h5') {
        this.bannerHeight += 50;
      }
    };
    this.listQuery.columnId = this.$getPartId(this.$route.path);
    this.listQuery.menuId = this.$getMenuId(this.$route.path);
    this.listTotal = 0;
    this.maxPage = 1;
    this.getList();
    this.getBanner();
    this.getLabels();
  },
  methods: {
    async loadMore() {
      // console.log(
      //   "loadMore",
      //   this.busy || this.listQuery.pageNum >= this.maxPage
      // );
      if (this.busy || this.listQuery.pageNum >= this.maxPage) return;
      this.busy = true;
      this.listQuery.pageNum += 1;
      await this.getList();
    },
    async getList() {
      this.$get(this.$api + '/cms/web/selsctWeb', this.listQuery)
        .then(
          (res) => {
            this.artData = [...this.artData, ...res.data];
            this.listTotal = res.total;
            this.maxPage = res.maxPage;

            let that = this;
            this.$nextTick(() => {
              that.nomore = true;
              setTimeout(() => {
                that.busy = false;
              }, 300);
            });
          }
        );
    },
    changeLabel(id, label) {
      this.listQuery.labelId = id;
      this.listQuery.pageNum = 1;
      this.currentLabel = label;
      this.artData = [];
      this.getList();
    },
    getLabels() {
      this.$get(this.$api + '/cms/web/getLabelByPartId', {
        partId: this.listQuery.columnId,
      })
        .then((res) => {
          this.labelData = res.data;
        });
    },
    getListMore() {
      this.listQuery.pageNum += 1;
      this.getList();
    },
    getBanner() {
      this.$get(this.$api + '/cms/web/partArticleBanner', {
        menuId: this.listQuery.menuId,
      })
        .then((res) => {
          res.data.forEach((item) => {
            if (item.bannerName === '热点聚焦') {
              this.international = item;
              return;
            } else {
              this.bannerData.push(item);
            }
          });
        });
    },
    changeBanner(index) {
      this.currentIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    viewTypeChange(type) {
      this.artData = [];
      this.listQuery.pageNum = 1;
      this.getList();
      this.currentView = type;
      this.$nextTick(() => {
        this.$redrawVueMasonry();
      });
    },
  },
};
</script>
<style>
.en #exclusive .banner-view .int-col .int-content .content-html p,
.en #exclusive .banner-view .int-col .int-content .content-html article {
  font-family: "Times New Roman", Times, serif !important;
}
</style>
<style lang="scss" scoped>
#exclusive {
  position: relative;
  width: 100%;

  &::after {
    // content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: url("../assets/images/djfb-bg.jpg") no-repeat;
    background-size: 100% auto;
    background-position: center 0;
  }

  .page {
    padding: fh(152vh, pc) fw(80vw, pc) 0 fw(80vw, pc);

    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.51) 0%,
        #ffffff 100%
    );

    ::v-deep .el-breadcrumb {
      // margin-left: fw(-40vw, pc);
      .el-breadcrumb__inner {
        font-weight: bold;
        color: #fff !important;
        font-size: fh(18vh, pc);
      }
    }
  }

  .page-content {
    background-color: #fff;
    padding: 0 fw(80vw, pc) fh(40vh, pc) fw(80vw, pc);
  }

  .art-row {
    display: flex;
    padding-top: fh(40vh, pc);
    width: 100%;

    .book-content {
      background-color: $fh90;
      padding-bottom: fh(40vh, pc);

      .book-btn {
        display: flex;
        width: 100%;
        align-items: flex-end;
        justify-content: center;

        img {
          width: fw(180vw, pc);

          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }
      }

      .book-row {
        display: flex;
        width: 100%;
        padding: fh(46vh, pc) fw(20vw, pc);
        color: $sh;

        img.book-img {
          width: fw(280vw, pc);
        }

        .book-text {
          padding-left: fw(10vw, pc);

          .view-label {
            color: $zh;
            position: relative;
            display: inline-block;
            font-size: fh(24vh, pc);
            font-weight: 800;
            margin-top: fh(20vh, pc);
            margin-bottom: fh(60vh, pc);

            &::after {
              content: "";
              position: absolute;
              bottom: fh(-16vh, pc);
              right: fw(-12vw, pc);
              width: fw(30vw, pc);
              height: fh(18vh, pc);
              border-right: fw(6vw, pc) solid hsla(14, 74%, 37%, 0.2);
              border-bottom: fw(8vw, pc) solid hsla(14, 74%, 37%, 0.2);
            }
          }

          .text-item {
            padding-bottom: fh(30vh, pc);

            .item-title {
              font-size: fh(18vh, pc);
              font-weight: bold;
              padding-bottom: fh(20vh, pc);
            }

            .item-content {
              font-size: fh(16vh, pc);
              line-height: fh(26vh, pc);
            }
          }
        }
      }
    }

    .row-right {
      display: flex;
      flex: 1;
      margin-left: fw(20vw, pc);
      flex-flow: column;

      .hot-article {
        width: 100%;
        padding: fh(30vh, pc) fw(30vw, pc);
        background-color: $fh90;
        margin-top: 0;

        .article-label {
          color: $zh;
          position: relative;
          display: inline-block;
          font-size: fh(24vh, pc);
          font-weight: 800;
          margin-top: fh(20vh, pc);
          margin-bottom: fh(60vh, pc);

          &::after {
            content: "";
            position: absolute;
            bottom: fh(-16vh, pc);
            right: fw(-12vw, pc);
            width: fw(30vw, pc);
            height: fh(18vh, pc);
            border-right: fw(6vw, pc) solid hsla(14, 74%, 37%, 0.2);
            border-bottom: fw(8vw, pc) solid hsla(14, 74%, 37%, 0.2);
          }
        }

        .article-view {
          color: $sh;

          .article-item {
            width: fw(485vw, pc);
            line-height: fh(26vh, pc);
            margin-bottom: fh(26vh, pc);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            span {
              color: $zh;
              font-size: fh(18vh, pc);
              font-weight: bold;
              display: inline-block;
              padding-right: fw(16vw, pc);
            }

            &:hover {
              opacity: 0.8;
              cursor: pointer;
              color: $zh;
            }
          }
        }
      }
    }
  }

  .art-col {
    position: relative;
    width: fw(1180vw, pc);
    margin-top: fh(20vh, pc);

    .art-tab {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: fh(30vh, pc);
      color: $sh;

      .tab-item {
        margin-right: fw(60vw, pc);
        font-size: fh(16vh, pc);
        position: relative;
        line-height: fh(24vh, pc);

        &:hover {
          color: $sh;
          cursor: pointer;
        }

        &.active {
          font-size: fh(20vh, pc);
          font-weight: bold;
          color: $sh;

          &::before {
            content: "";
            position: absolute;
            bottom: fh(-14vh, pc);
            width: 100%;
            border-top: fh(6vh, pc) solid $zh;
          }
        }
      }

      .tab-info {
        margin-left: auto;
        display: flex;
        align-items: center;

        .toggle-img {
          margin-left: fh(62vw, pc);
          margin-right: fh(24vw, pc);
        }

        img {
          width: fw(20vw, pc);
          cursor: pointer;
        }
      }
    }

    .art-view {
      cursor: pointer;

      &.text {
        .art-item {
          width: 100%;
        }

        .item-title {
          display: flex;
          width: 100%;

          .item-info {
            padding-left: fw(40vw, pc);
            margin-left: auto;
            width: max-content !important;

            .info-label {
              margin-right: fw(20vw, pc);
              width: max-content !important;
            }

            .info-time {
              width: max-content;
              margin-left: fw(20vw, pc) !important;
            }
          }
        }
      }

      .art-item {
        // break-inside: avoid;
        width: calc((100% - 40px) / 3);
        margin-bottom: fh(20vh, pc);
        background-color: $dh;

        &:hover {
          opacity: 0.9;
        }

        img {
          width: 100%;
        }

        .art-content {
          width: 100%;
          color: $sh;
          padding: fh(20vh, pc) fw(20vw, pc);
          position: relative;
          z-index: 2;
          background-color: $dh;

          .item-title {
            font-size: fh(16vh, pc);
            line-height: fh(20vh, pc);
            margin-bottom: fh(8vh, pc);
            font-weight: 600;
            color: $sh;
          }

          .item-info {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;
            margin-bottom: fh(0vh, pc);
            font-size: fh(14vh, pc);
            line-height: fh(20vh, pc);

            .info-time {
              color: #a1b8bd;
              margin-left: auto;
            }
          }

          .item-content {
            font-size: fh(14vh, pc);
            line-height: fh(20vh, pc);
            font-weight: 400;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .art-more {
      column-count: 1;
      column-gap: 0;
      width: max-content;
      margin: fh(40vh, pc) auto;
      color: rgba(0, 0, 0, 1);
      font-size: fh(14vh, pc);

      &.true:hover {
        cursor: pointer;
        opacity: 0.8;
        color: $zh;
      }

      &.none {
        opacity: 0.5;
      }
    }
  }

  .banner-view {
    display: flex;
    width: 100%;
    margin-top: fh(16vh, pc);

    .banner-col {
      width: fw(1180vw, pc);
      margin-right: fw(20vw, pc);
      position: relative;
      cursor: pointer;
      // ::v-deep .el-carousel__container {
      //   height: fh(610vh, pc) !important;
      // }
      .carousel-view {
        position: relative;

        .content-view {
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          padding: fw(20vw, pc) fw(40vw, pc);
          background: linear-gradient(180deg, rgba(34, 0, 0, 0.3) 0%, $sh 100%);
          color: #fff;

          .item-title {
            font-size: fh(20vh, pc);
            font-weight: 600;
            color: #fbfeff;
            line-height: fh(29vh, pc);
            padding-bottom: fh(12vh, pc);
          }

          .item-content {
            font-size: fh(14vh, pc);
            color: #ffffff;
            line-height: fh(20vh, pc);
          }
        }
      }

      .col-text {
        // position: absolute;
        // bottom: 0;
        // transform: translateY(100%);
        // left: 0;
        display: flex;
        // align-items: center;
        .text-item {
          flex: 1;
          color: $sh;
          padding: fh(20vh, pc) fw(20vw, pc);
          background-color: #f6f6f6;
          font-size: fh(16vh, pc);
          line-height: fh(24vh, pc);
          margin: 0 fw(2vw, pc);

          &.active {
            background-color: $zh;
            color: #fff;
          }

          &:nth-child(1) {
            margin-left: 0;
          }

          &:nth-last-child(1) {
            margin-right: 0;
          }

          &:hover {
            opacity: 0.8;
            cursor: pointer;
            color: #3B64FD;
          }
        }
      }

      .banner-big {
        width: 100%;
        display: block;
      }
    }

    .int-col {
      flex: 1;
      overflow: hidden;
      background: #f6f6f6;
      position: relative;

      .int-content {
        padding: fh(20vh, pc) fw(20vw, pc);
        max-height: fh(580vh, pc);
        overflow: hidden;

        .content-title {
          font-size: fh(24vh, pc);
          font-weight: 800;
          color: $zh;
          line-height: fh(35vh, pc);
          // &:hover {
          //   cursor: pointer;
          //   opacity: 0.8;
          // }
        }

        .content-import {
          margin-top: fh(40vh, pc);
          position: relative;
          color: $sh;
          padding: fh(24vh, pc) fw(20vw, pc);
          padding-bottom: fh(16vh, pc);
          background-color: rgba(213, 217, 220, 0.2);
          font-size: fh(16vh, pc);
          font-weight: 800;
          line-height: fh(24vh, pc);

          img {
            position: absolute;
            width: fw(22vw, pc);
          }

          .mh01 {
            left: fw(7vw, pc);
            top: 0;
            transform: translateY(-70%);
          }

          .mh02 {
            right: fw(7vw, pc);
            bottom: 0;
            transform: translateY(-30%);
          }

          // &::before {
          //   content: "“";
          //   font-family: cursive;
          //   position: absolute;
          //   font-size: fh(60vh, pc);
          //   left: fh(-20vw, pc);
          //   top: fh(5vh, pc);
          //   color: $zh;
          // }
          // &::after {
          //   content: "”";
          //   font-family: cursive;
          //   position: absolute;
          //   font-size: fh(60vh, pc);
          //   right: fh(-20vw, pc);
          //   bottom: fh(-24vh, pc);
          //   color: $zh;
          // }
        }

        ::v-deep .content-html {
          margin-top: fh(22vh, pc);
          word-wrap: break-word;
          overflow: hidden;
          height: fh(336vh, pc);
          color: $sh !important;

          strong {
            color: $sh;
          }

          p,
          article,
          section {
            font-size: fh(14vh, pc);
            font-family: "宋体", "songti", "宋体-简", "serif", "sans-serif",
            "cursive", "fantasy", "monospace";
            font-weight: 400;
            color: $sh;
            line-height: fh(24vh, pc) !important;
            margin-top: fh(24vh, pc) !important;
          }

          img,
          img + p,
          img + font,
          p font {
            max-width: 100%;
            display: none;
          }

          strong {
            background-color: rgba(255, 255, 255, 0) !important;
          }

          .html-title {
            font-size: fh(16vh, pc);
            font-weight: bold;
            color: #ffffff;
            line-height: fh(24vh, pc);
          }
        }

        .int-more {
          position: absolute;
          bottom: fh(0vh, pc);
          width: 100%;
          text-align: center;
          left: 0;
          font-size: fh(14vh, pc);
          font-weight: 600;
          line-height: fh(20vh, pc);
          color: #aeb1b3;
          padding: fh(20vh, pc);
          background: #f6f6f6;
          // &:after {
          //   content: "";
          //   position: absolute;
          //   bottom: 0;
          //   width: 100%;
          //   height: 100%;
          //   left: 0;
          //   color: #000;
          //   background: #f6f6f6;
          // }
          &:hover {
            cursor: pointer;
            color: $zh;
          }
        }
      }

      .label-view {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        padding: fh(40vh, pc) fw(20vw, pc) fh(28vh, pc) fw(20vw, pc);
        border-bottom: 2px solid rgba(0, 0, 0, 0.199);

        .int-label {
          color: $zh;
          position: relative;
          display: inline-block;
          font-size: fh(24vh, pc);
          font-weight: 800;

          img {
            position: absolute;
            bottom: fh(-12vh, pc);
            right: fw(-10vw, pc);
            width: fw(32vw, pc);
          }
        }
      }
    }
  }
}

#exclusive.h5 {
  .banner-view {
    flex-wrap: wrap;

    .banner-col {
      width: 100%;

      .col-text {
        width: 100%;
        flex-wrap: wrap;
        justify-content: space-between;

        .text-item {
          width: 100%;
          margin: 0;
          padding: fw(12vw, h5) !important;
          flex: none;
        }
      }
    }

    .int-col {
      margin-top: 12px;

      .label-view {
        padding: fw(20vw, h5) fw(12vw, h5);
      }

      .int-label {
        font-size: fh(18vh, h5);

        img {
          width: fw(22vw, h5);
          bottom: fh(-6vh, h5);
          right: fw(-6vw, h5);
        }
      }

      .int-content {
        padding: fw(12vw, h5);

        .mh02 {
          bottom: -12px;
        }
      }
    }
  }

  .art-col .art-tab .tab-info {
    font-size: fh(10vh, h5);

    img {
      width: fw(20vw, h5);
    }
  }

  .art-col .art-view {
    &.text {
      .art-item {
        width: 100%;
      }
    }

    .art-item {
      width: calc(50% - 10px);
      margin-bottom: fw(8vw, h5);

      .art-content {
        padding: fw(8vw, h5);
      }
    }
  }
}

.h5#exclusive .banner-view .int-col .int-content {
  padding-bottom: 0;
  max-height: min-content;

  .int-more {
    padding: 12px 0;
    font-size: 14px;
    line-height: 24px;
  }

  ::v-deep .content-html {
    margin-top: 24px;
    word-wrap: break-word;
    overflow: hidden;
    height: 336px !important;
    color: $sh !important;

    strong {
      color: $sh;
    }

    p,
    article,
    section {
      font-size: 14px;
      font-family: "宋体", "songti", "宋体-简", "serif", "sans-serif", "cursive",
      "fantasy", "monospace";
      font-weight: 400;
      color: $sh;
      line-height: 24px !important;
      margin-top: 24px !important;
    }
  }
}
</style>
